export type LeagueFormat = {
    id: number
    name: string
}

export const LEAGUE_FORMAT_STAGES_ID = 2
